export const STATUS_BADGE = {
  ACTIVE: { text: 'Active', color: 'success' },
  SUSPENDED: { text: 'Suspended', color: 'danger' },
  TERMINATED: { text: 'Terminated', color: 'secondary' },
};

export const PROFILE_STATUS_BADGE = {
  NOT_INITIALIZAD: { text: 'Not Initialized', color: 'secondary' },
  NOT_SUFFICIENT_HISTORY: { text: 'Non-sufficient history', color: 'warning' },
  OK: { text: 'Ok', color: 'success' },
  OUT_OF_DATE: { text: 'Out of date', color: 'secondary' },
};

export const NEW_PROFILE_STATUS_BADGE = {
  NOT_INITIALIZAD: { text: 'Not Initialized', color: 'secondary' },
  NOT_SUFFICIENT_HISTORY: { text: 'Non-sufficient history', color: 'warning' },
  OK: { text: 'Ok', color: 'success' },
  OUT_OF_DATE: { text: 'Out of date', color: 'info' },
};

export const PROFILE_VALIDITY_BADGE = {
  VALID: { text: 'Valid', color: 'success' },
  INVALID_CONSTANT: { text: 'Invalid', color: 'danger' },
  INVALID_TEMPORARY: { text: 'Invalid (temporary)', color: 'warning' },
};

export const PROFILE_PREDICTION_RISK_STATUS = {
  LOW_RISK: { text: 'Low Risk', color: 'success' },
  MEDIUM_RISK: { text: 'Medium Risk', color: 'warning' },
  HIGH_RISK: { text: 'High Risk', color: 'danger' },
};

export const PAYROLL_STATUS_BADGE = {
  NA: { text: 'N/A', color: 'secondary' },
  NOT_DETECTED: { text: 'Not Detected', color: 'danger' },
  UNKNOWN_FREQUENCY: { text: 'Unknown Frequency', color: 'warning' },
  OK: { text: 'Ok', color: 'success' },
  NOT_RECENT: { text: 'Not Recent', color: 'danger' },
  OUT_OF_DATE: { text: 'Out of date', color: 'secondary' },
};

export const BANK_ACCOUNT_STATUS_BADGE = {
  CONNECTED: { text: 'Connected', color: 'bg-success' },
  NOT_CONNECTED: { text: 'Not Connected', color: 'bg-warning' },
  REFRESH_REQUIRED: { text: 'Refresh Required', color: 'bo-badge-bg-border-red' },
  INVALID: { text: 'Invalid', color: 'bg-danger' },
  NO_TRANSFERS: { text: ' No Transfers', color: 'bg-info' },
};

export const INSTITUTION_CATEGORY_BADGE = {
  A: { text: 'A', color: 'bo-badge-bg-border-green' },
  B: { text: 'B', color: 'bo-badge-bg-border-green' },
  C: { text: 'C', color: 'bo-badge-bg-border-green' },
  D: { text: 'D', color: 'bo-badge-bg-border-yellow' },
};

export const JOB_STATUS_BADGE = {
  SUCCESS: { text: 'Succeeded', color: 'success' },
  RUNNING: { text: 'Running', color: 'info' },
  FAILED: { text: 'Failed', color: 'danger' },
  PENDING_ASSET_REPORT: { text: 'Pending Asset Report', color: 'warning' },
  QUEUE: { text: 'In Queue', color: 'warning' },
};

export const CARD_ASTRA_STATUS = {
  approved: { text: 'Approved', color: 'success' },
  pending: { text: 'Pending', color: 'warning' },
  flagged: { text: 'Flagged', color: 'warning' },
  rejected: { text: 'Rejected', color: 'danger' },
  unreviewed: { text: 'Unreviewed', color: 'warning' },
};

export const CARD_VERIFICATION_STATUS = {
  PENDING: { text: 'Pending', color: 'warning' },
  VERIFIED: { text: 'Verified', color: 'success' },
  UNVERIFIED: { text: 'Unverified', color: 'danger' },
};

export const CARD_STATUS = {
  OK: { text: 'Ok', color: 'success' },
  PENDING_APPROVAL: { text: 'Pending Approval', color: 'warning' },
  EXPIRED: { text: 'Expired', color: 'danger' },
  CANCELED: { text: 'Canceled', color: 'danger' },
  INVALID: { text: 'Invalid', color: 'danger' },
  BLOCKED_BY_BRIDGEOVER: { text: 'Blocked by Bridgeover', color: 'danger' },
};

export const CONSUMER_NO_OFFER_REASON = {
  OPEN_FUNDING_IS_DUE: 'Open advance is due',
  NO_PREDICTED_PAYDAY: "Can't predict next payday",
  NO_AVAILABLE_LIMIT: 'No available limit',
  CONSUMER_NOT_ACTIVE: 'Consumer not active',
  NO_EMPLOYER: 'No employer',
  CONSUMER_PAYROLL_STATUS: 'Payroll status does not allow',
  NOT_ENOUGH_PAYCHECKS: 'Not enough paychecks',
  EMPLOYMENT_PERIOD_TOO_SHORT: 'Employment period is too short',
  OPEN_FUNDING_IS_CLOSING: "Open advance in 'Closing' state",
  NO_FUNDING_SOURCE: 'No funding source',
  NON_SUFFICIENT_HISTORY: 'Non-sufficient history',
  PROFILE_OUT_OF_DATE: 'Profile is out-of-date',
  NO_PAYMENTS_DETECTED: 'No payments detected',
  NON_TOPUP_REPAYMENT_MODE: 'Repayment mode does not allow top-up',
  INSUFFICIENT_BRIDGEPOINTS: 'Insufficient Bridgepoints',
  CARD_NOT_AVAILABLE: 'No card on file',
  INVALID_CARD: 'Main card is invalid',
  PAYROLL_NOT_RECENT: 'Recent payroll is missing',
  CARD_PENDING_APPROVAL: 'Card is pending approval',
  CONSUMER_SERVICE_TYPE: 'CONSUMER_SERVICE_TYPE',
  NO_KYC: 'KYC is not cleared',
  NO_SSN: 'Last 4 SSN digits are missing',
  NOT_ELIGIBLE_HIGH_RISK: 'Not eligible due to high risk',
  NOT_ELIGIBLE_RISK_ASSESSMENT_REQUIRED: 'Not eligible - Risk assessment is required',
  EMPLOYEE_RECORD_NOT_FOUND: 'Employee record not found',
  UNKNOWN: 'Unknown reson',
};

export const CONSUMER_JOB_STATUS = {
  QUEUE: 'Waiting in queue',
  PENDING_ASSET_REPORT: 'Waiting for assets report',
  RUNNING: 'Running',
  SUCCESS: 'Finished successfully',
  FAILED: 'Failed',
  UNKNOWN: 'Unknown',
};

export const CONSUMER_TRANSACTIONS_COLORS = [
  { bgColor: '#7c0000', color: 'white' },
  { bgColor: 'orange', color: 'white' },
  { bgColor: 'gray', color: 'white' },
  { bgColor: '#366092', color: 'white' },
  { bgColor: '#008000', color: 'white' },
  { bgColor: '#974706', color: 'white' },
  { bgColor: '#60497A', color: 'white' },
  { bgColor: '#B8CCE4', color: 'black' },
  { bgColor: '#89FF89', color: 'black' },
  { bgColor: '#FABF8F', color: 'black' },
  { bgColor: '#CCC0DA', color: 'black' },
  { bgColor: '#95B3D7', color: 'black' },
  { bgColor: '#00C800', color: 'black' },
  { bgColor: '#E26B0A', color: 'black' },
  { bgColor: '#B1A0C7', color: 'black' },
  { bgColor: 'yellow', color: 'black' },
  { bgColor: 'green', color: 'black' },
  { bgColor: 'blue', color: 'black' },
  { bgColor: 'lime', color: 'black' },
  { bgColor: 'teal', color: 'black' },
  { bgColor: 'purple', color: 'black' },
];

export const PAYROLL_FREQUENCIES = {
  WEEKLY: 'Weekly',
  BIWEEKLY: 'Bi-Weekly',
  SEMI_MONTHLY: 'Semi-Monthly',
  MONTHLY: 'Monthly',
};

export const CONSUMER_KYC_STATUS = {
  APPROVED: { color: 'success', text: 'Approved' },
  REJECTED: { color: 'danger', text: 'Rejected' },
  PENDING_REVIEW: { color: 'info', text: 'Pending Review' },
  IN_PROGRESS: { color: 'warning', text: 'In Progress' },
  OTHER: { color: 'secondary', text: 'Other' },
};

export const REWARDS_STATUS_BADGE = {
  OFFERED_TEST: { text: 'Offered Test', color: 'secondary' },
  OFFERED: { text: 'Offered', color: 'secondary' },
  IN_PROGRESS: { text: 'In Progress', color: 'info' },
  SUCCEEDED: { text: 'Succeeded', color: 'success' },
  FAILED: { text: 'Failed', color: 'danger' },
};

export const REWARDS_SURVEY_STATUS_BADGE = {
  OFFERED_TEST: { text: 'Offered Test', color: 'secondary' },
  OFFERED: { text: 'Offered', color: 'secondary' },
  IN_PROGRESS: { text: 'In Progress', color: 'info' },
  SUCCEEDED: { text: 'Completed', color: 'success' },
  FAILED: { text: 'Expired', color: 'danger' },
};

export const REWARDS_CATEGORIES = ['ARTICLE', 'VIDEO', 'SURVEY', 'CHALLENGE'];

export const REWARDS_STATUS_TYPE_BADGE = {
  ACTIVE: { text: 'Active', color: 'success' },
  DISABLED: { text: 'Disabled', color: 'secondary' },
  TEST: { text: 'Test', color: 'info' },
};

export const ADVANCE_ELIGIBILITY_BADGE = {
  ELIGIBLE: { text: 'Eligible', color: 'success' },
  NOT_ELIGIBLE_HIGH_RISK: { text: 'Not Eligible - High Risk', color: 'danger' },
  NOT_ELIGIBLE_RISK_ASSESSMENT_REQUIRED: {
    text: 'Not Eligible - Risk Assessment Required',
    color: 'warning',
  },
};

export const ADVANCE_ELIGIBILITY_BADGE_SHORT = {
  ELIGIBLE: { text: 'Eligible', color: 'success' },
  NOT_ELIGIBLE_HIGH_RISK: { text: 'High Risk', color: 'danger' },
  NOT_ELIGIBLE_RISK_ASSESSMENT_REQUIRED: { text: 'Risk Assessment', color: 'warning' },
};
